/** 查询所有角色 */
export const getAllRole = '/role/listAll'

/** 查询所有站点 */
export const getAllSite = '/admin/country/list'

/** 查询平台和站点下 所有的店铺 */
export const getAllStore = '/task/store/queryStorePushList'

/** 查询平台和站点下 所有的店铺 不带分页 */
export const queryStorePushList = '/task/store/queryStorePushList'

/** 查询平台和站点下 所有已开启的店铺 */
export const queryStorePushListWithAuth = '/task/store/queryStorePushListWithAuth'

/** 查询所有刷手 */
export const getAllService = '/admin/allServiceList'

/** 查询所有海外负责人 */
export const getAllLeaderList = '/admin/allLeaderList'

/** 查询所有的公司 */
export const getAllCompany = '/admin/company/queryCompanyList'

/** 查询商家所有站点 */
export const getAllCompanySite = '/admin/country/companyCountryList'




// WEBPACK FOOTER //
// ./src/http/moudules/allApi.js